import {VIEW_CHANNEL_LINEUP} from 'src/shared/channelTracking/constants/actionIds';
import {VIDEO} from 'src/shared/channelTracking/constants/intent';
import {SUCCESS, FAILED} from 'src/shared/channelTracking/constants/status';
import {VID_REPAIR} from 'src/shared/channelTracking/constants/interactionType';

export const viewSuccess = {
  action: {
    id: VIEW_CHANNEL_LINEUP,
    intent: VIDEO,
    status: SUCCESS,
  },
  eventTimestamp: Date.now().toString(),
  interactionType: VID_REPAIR,
};

export const viewError = {
  action: {
    id: VIEW_CHANNEL_LINEUP,
    intent: VIDEO,
    status: FAILED,
  },
  eventTimestamp: Date.now().toString(),
  interactionType: VID_REPAIR,
};
